const BlogContent = [
    {
        images: '01',
        title: "'It's not like the movies': Ex-inmates explain why this 'lockdown' isn't just like prison",
        category: 'ABC News'
    },
    {
        images: '02',
        title: 'Labels.... good on jars, not so much on humans',
        category: 'LinkedIn Article'
    },
    {
        images: '03',
        title: 'If you Want a Safe Community, Employ Someone With a Criminal Record',
        category: 'Podcast'
    },
    {
        images: '04',
        title: ' Getting tickets to the big show',
        category: 'Development'
    },
    {
        images: '05',
        title: 'A big ticket gone to be an interesting ',
        category: 'Management'
    },
    {
        images: '06',
        title: 'The Home of the Future Could Bebes',
        category: 'Design'
    },
    {
        images: '07',
        title: 'The Home of the Future Could Bebes',
        category: 'Design'
    },
]

export default BlogContent;